import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import template from './investment-preferences.component.html';
import styles from './investment-preferences.component.scss';

@Component({
  selector: 'investment-preferences',
  template,
  styles: [styles],
})
export class InvestmentPreferencesComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }
  ngOnInit() {
    const steps = this.flowManager.getStepArrays('investment-preferences');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    if (this.form.stepsToComplete.length > 0) {
      this.form.buttons.inputs.next.path = `/${this.form.stepsToComplete[0].route}`;
    } else {
      this.form.buttons.inputs.next.path = '/submit-application';
    }
  }
}
